import { OrderBaseDetailsDTO } from '@onArte/shared/interfaces/common';

export class SalesListElementDTO extends OrderBaseDetailsDTO {}
